import PlanRepository from "../../../domain/plan/PlanRepository";
import PlanDataSource from "../../../infrastructure/datasource/plan/PlanDataSource";

class GetPlansCount {
  constructor(
    private readonly repository: PlanRepository = new PlanDataSource()
  ) {
  }
  public async execute(): Promise<number> {
    try {
      const response = await this.repository.countByPage();
      // @ts-ignore
      return Promise.resolve(Number(response.data));
    } catch (e) {
      return Promise.reject(0);
    }
  }
}

export default GetPlansCount;
